import { Box, Card, Grid, Typography } from "@mui/material";
import React from "react";
import DisableBlueSmallButton from "../../../../components/customButtons/DisableSmallBlueButton";
import BlueSmallButton from "../../../../components/customButtons/BlueSmallButton";
import { FiUpload } from "react-icons/fi";
import { Icon } from "@iconify/react";
import { MdOutlinePersonOutline } from "react-icons/md";
import { CiClock2 } from "react-icons/ci";
import { FaExternalLinkAlt, FaRegFileAlt } from "react-icons/fa";
import { FiEye } from "react-icons/fi";
import UploadAssignmentForm from "./UploadAssignmentForm";
import CustomPopup from "../../../../components/customPopup/CustomPopup";
import GlobalCustomPopup from "../../../../components/customPopup/GlobalCustomPopup";
import ViewSubmission from "./ViewSubmission";
import { fDate } from "./../../../../../utils2/formatTime";
import { set } from 'date-fns';
import UploadNewAssignment from "./UploadNewAssignment";

export default function AllAssignments({ filterdData ,setFilteredData}) {
  const [openUploadModal, setOpenUploadModal] = React.useState(false);
  const [selectedData, setSelectedData] = React.useState(null);
  const [openViewModal, setOpenViewModal] = React.useState(false);

  const handleOpenUploadModal = (item) => {
    setOpenUploadModal(true);
    setSelectedData(item);
  };

  const handleCloseUploadModal = () => {
    setOpenUploadModal(false);
  };

  const handleOpenViewModal = (item) => {
    setOpenViewModal(true);
    setSelectedData(item);
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
  };

  const statusConfig = {
  Submitted: {
    bg: "#EAFEF4",
    color: "#008040",
  border: "1px solid #C0EDD6",
    icon: <FaRegFileAlt size={18} />
  },
  Pending: {
    bg: "#FFF6E6",
    color: "#C98200",

    border: "1px solid #FFE2AC",
    icon: <CiClock2 size={20} />
  },
  Rejected:{
    bg: "#FFF2F2",
    color: "#C90000",
    border: "1px solid #FFC9C9",
    icon: <FaRegFileAlt size={18} />
  },
  Default: {
    bg: "#FAF2FF",
    color: "#7C479D",
    border: "1px solid #E0CEEB",
    icon: <Icon icon="mdi:poll" width="18" />
  }
};



  return (
    <>
      {filterdData?.map((item, index) => {
        const currentStatus = statusConfig[item?.status] || statusConfig.Default;
        return (
          
        
        <Card
          sx={{
            borderRadius: "12px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            borderLeft: "3px solid #DA5DC7", // purple left border
            mb: 3,
            p: "15px",
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} md={8} container gap={1} alignItems="center">
              <Typography
                style={{ fontSize: "16px", fontWeight: 700, color: "#161719" }}
                gutterBottom
              >
                {item?.title}
              </Typography>
              <Box
                sx={{ display: "inline-flex" }}
                onClick={() => window.open(item?.assignment_link)}
              >
                <FaExternalLinkAlt size={14} color="#0E87B7" />
              </Box>
            </Grid>

         <Grid item xs={12} md={4} textAlign="right">
  <Box
    sx={{
      display: "inline-flex",
      background: currentStatus.bg,
       border: currentStatus.border,
      px: "10px",
      py: "5px",
      borderRadius: "8px",
      color: currentStatus.color,
      fontSize: "12px",
      fontWeight: 400,
      gap: "5px",
      alignItems: "center",
    }}
  >
    {currentStatus.icon}
    <Typography>{item?.status}</Typography>
  </Box>
</Grid>


            <Grid item xs={12} display="flex" alignItems="center" gap={4}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Icon icon="system-uicons:document" width="22" height="22" />
                <Typography
                  sx={{
                    color: "#161719",
                    fontSize: "14px",
                    fontWeight: 400,
                    ml: 0.5,
                  }}
                >
                  {item?.test_type_id?.name}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Icon icon="streamline-plump:module" width="18" height="18" />
                <Typography
                  sx={{
                    color: "#161719",
                    fontSize: "14px",
                    fontWeight: 400,
                    ml: 0.5,
                  }}
                >
                  {item?.assignment_type}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <MdOutlinePersonOutline size={22} />
                <Typography
                  sx={{
                    color: "#161719",
                    fontSize: "14px",
                    fontWeight: 400,
                    ml: 0.5,
                  }}
                >
                  {item?.trainer_id?.first_name} {item?.trainer_id?.last_name}
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: item?.status === "Pending" ? "#D23030" : "#008844",
                }}
              >
                <CiClock2 size={18} />
                <Typography
                  sx={{
                    color: item?.status === "Pending" ? "#D23030" : "#008844",
                    fontSize: "14px",
                    fontWeight: 400,
                    ml: 1,
                  }}
                >
                  {" "}
                  {item?.status === "Pending"
                    ? "Due : " + fDate(item?.due_date)
                    : "Submitted : " + fDate(item?.submitted_detail?.submitted_date)}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                style={{
                  background: "#FFF9EE",
                  padding: "10px",
                  borderRadius: "10px",
                  display: "inline-block",
                }}
              >
                <Typography
                  sx={{ color: "#313439", fontSize: "14px", fontWeight: 400 }}
                >
                  {" "}
                  {item?.status === "Graded"
                    ? "Feedback : " + item?.submitted_detail?.feedback
                    : item?.status==="Rejected" ?
                    "Declined Reason : " + item?.submitted_detail?.reason_for_decline

                    :"Instructions : " + item?.description}
                </Typography>
              </Box>
            </Grid>

{item?.status !== "Graded" && (
   <Grid item xs={12} sm={6} textAlign="left">
             
              <Typography
                  sx={{ color: "#A40583", fontSize: "14px", fontWeight: 700 }}
                >
                 Max Marks : {item?.max_marks}
                </Typography>
            </Grid>
)}

{item?.status === "Graded" && (
     <Grid item xs={12} sm={6} textAlign="left">
                <Typography
                  sx={{ color: "#A40583", fontSize: "14px", fontWeight: 700 }}
                >
                  Marks Obtained  : {item?.submitted_detail?.obtained_marks}/{item?.max_marks}
                </Typography>

                </Grid>
              )}
           

            <Grid item xs={12} sm={6} textAlign="right">
              {item?.status === "Pending" && (
                <BlueSmallButton
                  startIcon={<FiUpload size={20} />}
                  buttonTitle="Upload Assignment"
                  onClick={() => handleOpenUploadModal(item)}
                />
              )}

              {item?.status !== "Pending" && (
             
                <BlueSmallButton
                  startIcon={<FiEye size={18} />}
                  buttonTitle="View Submission"
                  onClick={() => {
                    handleOpenViewModal(item);
                  }}
                />
      )}
              

              
            </Grid>
          </Grid>
        </Card>
      )})}

      <GlobalCustomPopup
        handleClose={handleCloseUploadModal}
        component={
          <UploadNewAssignment
            handleClose={handleCloseUploadModal}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
            setFilteredData={setFilteredData}
            // handleOpenSuccessPopup={handleOpenSuccessPopup}
          />
        }
        open={openUploadModal}
        title="Upload Assignment"
        titleColor="#FFFFFF"
        maxWidth="sm"
        titleAlign="start"
      />

      <GlobalCustomPopup
        handleClose={handleCloseViewModal}
        component={
          <ViewSubmission
            handleClose={handleCloseViewModal}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
            setFilteredData={setFilteredData}
            // handleOpenSuccessPopup={handleOpenSuccessPopup}
          />
        }
        open={openViewModal}
        title="View Submission"
        titleColor="#FFFFFF"
        maxWidth="md"
        titleAlign="start"
      />
    </>
  );
}
